import Link from "next/link";
import { useUserContext } from "../context/UserContext";
// import { FaUser, FaRegUser } from "react-icons/fa";
import { RiUser6Line, RiUser6Fill } from "react-icons/ri";
import { useRouter } from "next/router";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // Import Tippy.js CSS

const ProfileUser = () => {
  const router = useRouter();
  const activePath = router.asPath;
  const siteVersion = router.pathname.substring(0, 3);

  const loginText = siteVersion === "/fr" ? "Connexion" : "Log in";

  const { userInfo, error, loading } = useUserContext();

  if (loading) {
    return null;
  }

  if (!userInfo) {
    return (
      <Tippy  className="customTooltip" content={siteVersion === "/fr" ? "Me connecter" : "Log in"}>
          <Link href="/login"><RiUser6Line  className="search-top-logo" /></Link>
      </Tippy>
    );
  }

  return (
    <Tippy  className="customTooltip" content={userInfo.username.slice(0,7)}>
        <Link href="/my-profile"><RiUser6Fill className="search-top-logo" /></Link>
    </Tippy>
  );
};

export default ProfileUser;